import React, { useState } from "react";
import Header from "../components/header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { SuwasthiLoader } from "../components/loader";

const EmployeeRegistration = () => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    employeeCode: "",
    fullName: "",
    department: "",
    designation: "",
    reportingManager: "",
    email: "",
    phone: "",
    birthDate: "",
    aadharCard: "",
    panCard: "",
    bloodGroup: "",
    fatherName: "",
    fatherOccupation: "",
    fatherPhone: "",
    maritalStatus: "",
    spouseName: "",
    spouseOccupation: "",
    spousePhone: "",
    dateOfJoining: "",
    emergencyContactName: "",
    emergencyContactRelationship: "",
    emergencyContactPhone: "",
    emergencyContactAddress: "",
    bankName: "",
    accountHolderNumber: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
    branchName: "",
    currentAddress: {
      type: "home",
      name: "",
      address1: "",
      address2: "",
      city: "",
      province: "",
      country: "",
      zipCode: "",
      landmark: "",
      phone: "",
      email: "",
      provinceCode: "",
      countryCode: "",
      latitude: null,
      longitude: null,
    },
    permanentAddress: {
      type: "home",
      name: "",
      address1: "",
      address2: "",
      city: "",
      province: "",
      country: "",
      zipCode: "",
      landmark: "",
      phone: "",
      email: "",
      provinceCode: "",
      countryCode: "",
      latitude: null,
      longitude: null,
    },
    isPermanentSame: false,
  });

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${apiurl}/api/employee/update`, formData);
      console.log('Success:', response.data);
      alert('Employee registered successfully!');

      // Navigate to another page after success
      navigate('/next-page');  // <-- your target route here

    } catch (error) {
      console.error('Error submitting form:', error.response?.data || error.message);
      alert('Something went wrong. Please try again.');
    }
  };

  const handleAddressChange = (addressType, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [addressType]: {
        ...prev[addressType],
        [field]: value,
      },
    }));
  };

  const handleSameAsCurrent = (e) => {
    const checked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      isPermanentSame: checked,
      permanentAddress: checked
        ? { ...prev.currentAddress }
        : prev.permanentAddress,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "accountNumber" || name === "confirmAccountNumber") {
      setErrors((prev) => ({
        ...prev,
        accountMismatch:
          (name === "confirmAccountNumber" || name === "accountNumber") &&
          formData.accountNumber !== value &&
          name === "confirmAccountNumber",
      }));
    }
  };


  return (
    <>
      <Header title="Employee Registration" />

      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-2 py-4">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-3xl border border-[#39160d]"
        >
          <h2 className="text-3xl font-bold mb-6 text-center">
            Employee Registration
          </h2>

          {/* Basic Details */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Basic Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* <InputField label="Employee Code" name="employeeCode" value={formData.employeeCode} onChange={handleChange} /> */}
            <InputField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
            <InputField
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
            {/* <InputField label="Reporting Manager" name="reportingManager" value={formData.reportingManager} onChange={handleChange} /> */}
            <InputField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
            />
            <InputField
              label="Phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
            />
            <InputField
              label="Birth Date"
              name="birthDate"
              type="input"
              value={formData.birthDate}
              onChange={handleChange}
            />
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Marital Status
              </label>
              <select
                name="maritalStatus"
                value={formData.maritalStatus}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select Status</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="widowed">Widowed</option>
                <option value="divorced">Divorced</option>
              </select>
            </div>
          </div>

          {/* Identification & Address */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Identification Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Aadhar Card"
              name="aadharCard"
              value={formData.aadharCard}
              onChange={handleChange}
            />
            <InputField
              label="PAN Card"
              name="panCard"
              value={formData.panCard}
              onChange={handleChange}
            />
            {/* <InputField
              label="Blood Group"
              name="bloodGroup"
              value={formData.bloodGroup}
              onChange={handleChange}
            /> */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Blood Group
              </label>
              <select
                name="bloodGroup"
                value={formData.bloodGroup}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* <InputField
              label="Current Address"
              name="currentAddress"
              value={formData.currentAddress}
              onChange={handleChange}
            />
            <InputField
              label="Permanent Address"
              name="permanentAddress"
              value={formData.permanentAddress}
              onChange={handleChange}
            /> */}
          </div>

          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Address Details
          </h3>

          <h4 className="font-bold mb-2">Current Address</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select
              value={formData.currentAddress.type}
              onChange={(e) =>
                handleAddressChange("currentAddress", "type", e.target.value)
              }
              className="w-full p-3 border rounded-xl mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="home">Home</option>
              <option value="office">Office</option>
              <option value="other">Other</option>
            </select>
            {[
              "address1",
              "address2",
              "city",
              "province",
              "country",
              "zipCode",
              "landmark",
            ].map((field) => (
              <input
                key={field}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={formData.currentAddress[field]}
                onChange={(e) =>
                  handleAddressChange("currentAddress", field, e.target.value)
                }
                className="w-full p-3 border rounded-xl mb-2"
              />
            ))}
          </div>

          {/* Permanent Address with Checkbox */}

          <div>
            <h4 className="font-bold mb-2 flex justify-between items-center">
              Permanent Address
            </h4>

            <label className="flex items-center mb-3">
              <input
                type="checkbox"
                checked={formData.isPermanentSame}
                onChange={handleSameAsCurrent}
                className="mr-2"
              />
              Same as Current Address
            </label>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select
              value={formData.permanentAddress.type}
              onChange={(e) =>
                handleAddressChange("permanentAddress", "type", e.target.value)
              }
              disabled={formData.isPermanentSame}
              className="w-full p-3 border rounded-xl mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
            >
              <option value="home">Home</option>
              <option value="office">Office</option>
              <option value="other">Other</option>
            </select>

            {[
              "address1",
              "address2",
              "city",
              "province",
              "country",
              "zipCode",
              "landmark",
            ].map((field) => (
              <input
                key={field}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={formData.permanentAddress[field]}
                onChange={(e) =>
                  handleAddressChange("permanentAddress", field, e.target.value)
                }
                className="w-full p-3 border rounded-xl mb-2"
                disabled={formData.isPermanentSame}
              />
            ))}
          </div>

          {/* Job Details */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Job Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Department"
              name="department"
              value={formData.department}
              onChange={handleChange}
            />
            <InputField
              label="Designation"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
            />
            <InputField
              label="Date Of Joining"
              name="dateOfJoining"
              type="date"
              value={formData.dateOfJoining}
              onChange={handleChange}
            />
            <InputField
              label="Reporting Manager"
              name="reportingManager"
              value={formData.reportingManager}
              onChange={handleChange}
            />
          </div>

          {/* Family Details */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Family Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Father's Name"
              name="fatherName"
              value={formData.fatherName}
              onChange={handleChange}
            />
            <InputField
              label="Father's Occupation"
              name="fatherOccupation"
              value={formData.fatherOccupation}
              onChange={handleChange}
            />
            <InputField
              label="Father's Phone"
              name="fatherPhone"
              value={formData.fatherPhone}
              onChange={handleChange}
            />
            <InputField
              label="Spouse Name"
              name="spouseName"
              value={formData.spouseName}
              onChange={handleChange}
            />
          </div>

          {/* Emergency Contact */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Emergency Contact Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Emergency Contact Name"
              name="emergencyContactName"
              value={formData.emergencyContactName}
              onChange={handleChange}
            />
            {/* <InputField
              label="Relationship"
              name="emergencyContactRelationship"
              value={formData.emergencyContactRelationship}
              onChange={handleChange}
            /> */}
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Relationship
              </label>
              <select
                name="emergencyContactRelationship"
                value={formData.emergencyContactRelationship}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select Relationship</option>
                <option value="father">Father</option>
                <option value="mother">Mother</option>
                <option value="spouse">Spouse</option>
                <option value="brother">Brother</option>
                <option value="sister">Sister</option>
                <option value="friend">Friend</option>
                <option value="other">Other</option>
              </select>
            </div>
            <InputField
              label="Emergency Contact Phone"
              name="emergencyContactPhone"
              value={formData.emergencyContactPhone}
              onChange={handleChange}
            />
            <InputField
              label="Emergency Contact Address"
              name="emergencyContactAddress"
              value={formData.emergencyContactAddress}
              onChange={handleChange}
            />
          </div>

          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Bank Details
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Bank Name"
              name="bankName"
              placeholder="Bank Name"
              value={formData.bankName}
              onChange={handleChange}
            />

            <InputField
              label="Account Holder Number"
              name="accountHolderNumber"
              placeholder="Account Holder Number"
              value={formData.accountHolderNumber}
              onChange={handleChange}
            />

            <InputField
              label="Account Number"
              name="accountNumber"
              placeholder="Account Number"
              value={formData.accountNumber}
              onChange={handleChange}
            />

            <InputField
              label="Confirm Account Number"
              name="confirmAccountNumber"
              placeholder="Confirm Account Number"
              value={formData.confirmAccountNumber}
              onChange={handleChange}
            />

            <InputField
              label="IFSC Code"
              name="ifscCode"
              placeholder="IFSC Code"
              value={formData.ifscCode}
              onChange={handleChange}
            />

            <InputField
              label="Branch Name"
              name="branchName"
              placeholder="Branch Name"
              value={formData.branchName}
              onChange={handleChange}
            />
          </div>
          {errors.accountMismatch && (
            <div className="text-red-500 col-span-2 text-sm">
              Account Number and Confirm Account Number do not match!
            </div>
          )}

          <button
            type="submit"
            className="bg-blue-600 text-white mt-10 font-semibold py-3 px-6 rounded-2xl w-full hover:bg-blue-700 transition"
          >
            Register Employee
          </button>
        </form>
      </div>
    </>
  );
};

const InputField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
}) => (
  <div>
    <label
      htmlFor={name}
      className="block text-sm font-medium text-gray-600 mb-1"
    >
      {label}
    </label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
);

export default EmployeeRegistration;
